// src/Layout/Sidebar/Menu.js

export const MENUITEMS = [
  {
    menutitle: "MAIN",
    menucontent: "Core Platform",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/dashboard`,
        icon: "home",
        title: "Dashboard",
        type: "link",
        permission: "dashboard",
      },
    ],
  },

  {
    menutitle: "USER MANAGEMENT",
    menucontent: "Users & Access",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/users`,
        icon: "users",
        title: "Users",
        type: "link",
        permission: "users",
      },
      {
        path: `${process.env.PUBLIC_URL}/departments`,
        icon: "layers",
        title: "Departments",
        type: "link",
        permission: "departments",
      },
      // {
      //   path: `${process.env.PUBLIC_URL}/roles`,
      //   icon: "shield",
      //   title: "Roles & Permissions",
      //   type: "link",
      //   permission: "roles",
      // },
    ],
  },

  {
    menutitle: "COMMUNICATION",
    menucontent: "Rooms & Messaging",
    Items: [
      // {
      //   path: `${process.env.PUBLIC_URL}/rooms`,
      //   icon: "message-square",
      //   title: "Groups / Rooms",
      //   type: "link",
      //   permission: "rooms",
      // },
      {
        path: `${process.env.PUBLIC_URL}/teams-groups`,
        icon: "users",
        title: "Teams & Groups",
        type: "link",
        permission: "rooms",
      },
      {
        path: `${process.env.PUBLIC_URL}/meetings`,
        icon: "video",
        title: "Meetings",
        type: "link",
        permission: "rooms",
      },

      {
        path: `${process.env.PUBLIC_URL}/broadcasts`,
        icon: "send",
        title: "Broadcasts",
        type: "link",
        permission: "broadcasts",
      },
      {
        title: "WhatsApp Mapping",
        icon: "message-circle",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/whatsapp/mappings`,
            title: "Mappings",
            type: "link",
            permission: "whatsapp_mappings",
          },
          {
            path: `${process.env.PUBLIC_URL}/whatsapp/logs`,
            title: "Routing Logs",
            type: "link",
            permission: "whatsapp_logs",
          },
        ],
      },
    ],
  },

  {
    menutitle: "COMPLIANCE",
    menucontent: "Audit & Security",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/audit`,
        icon: "file-text",
        title: "Audit Logs",
        type: "link",
        permission: "audit",
      },
      {
        path: `${process.env.PUBLIC_URL}/media`,
        icon: "image",
        title: "Media Repository",
        type: "link",
        permission: "media",
      },
      {
        path: `${process.env.PUBLIC_URL}/security`,
        icon: "lock",
        title: "Security",
        type: "link",
        permission: "security",
      },
      {
        path: `${process.env.PUBLIC_URL}/document-security`,
        icon: "lock",
        title: "Document Security",
        type: "link",
        permission: "document_security",
      },
    ],
  },

  {
    menutitle: "ANALYTICS",
    menucontent: "Reports & Insights",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/reports`,
        icon: "bar-chart",
        title: "Reports",
        type: "link",
        permission: "reports",
      },
    ],
  },

  {
    menutitle: "SYSTEM",
    menucontent: "Configuration & Health",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/settings`,
        icon: "settings",
        title: "System Settings",
        type: "link",
        permission: "settings",
      },
      {
        path: `${process.env.PUBLIC_URL}/health`,
        icon: "activity",
        title: "Health & Operations",
        type: "link",
        permission: "health",
      },
      {
        path: `${process.env.PUBLIC_URL}/support`,
        icon: "help-circle",
        title: "Support Center",
        type: "link",
        permission: "support",
      },
    ],
  },

  {
    menutitle: "ACCOUNT",
    menucontent: "Profile & Sessions",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/profile`,
        icon: "user",
        title: "My Profile",
        type: "link",
        permission: "profile",
      },
    ],
  },
];
